// export const formatPhoneNumber = (phone?: string) =>
//   phone?.startsWith("0") ? `+381${phone.substring(1)}` : phone;

export const stripPhonePrefix = (phone?: string): string | undefined => {
  if (!phone) return phone;
  const trimmed = phone.trim();
  if (trimmed.startsWith("+381")) return trimmed.slice(4);
  if (trimmed.startsWith("381") && trimmed.length > 3) return trimmed.slice(3);
  return trimmed;
};

export const maxChar = (str: string = "", maxLength: number = 30) =>
  str.length > maxLength ? `${str.substring(0, maxLength)}...` : str;
